import { getData } from './cookie';

export const getProductsByCategory=async(category, currpage=1)=>{
  const res = await getFromAPI(category, currpage);
  const products = JSON.parse(res || "{}")?.data;

  return { products };
}

export const getFeatured=async()=>{
  let res = "{}";
  res = await getData("abejike-featured", `${process.env.REACT_APP_REST_API_URL}/product/featured/1/4/null`);
  const {data, collection} = JSON.parse(res);
  return {featured:data, collection};
}

const getFromAPI=async(category, currpage)=>{
    try {
      const lastDoc = localStorage.getItem("lastDoc") || null;
      return await getData(`abejike-products-${category}-${currpage}`, `${process.env.REACT_APP_REST_API_URL}/product/${category}/1/10/${lastDoc}`);
    } catch (error) {
        console.error("Error getting products from API:", error);
        return {};
    }
}

export const getOrder=async(id)=>{
  const response = await fetch(`${process.env.REACT_APP_REST_API_URL}/order/${id}`);
  return await response.json();
}

export const getDiscount=async(code)=>{
  const response = await fetch(`${process.env.REACT_APP_REST_API_URL}/order/discount/${code}`);
  return await response.json();
}

export const createPaymentIntent=async(cartData)=>{
  try {
    const response = await fetch(`${process.env.REACT_APP_REST_API_URL}/payment/intent`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData),
    });
    return await response.json(); 
  } catch (error) {
    return {};
  }
}